var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-inner"},[_c('ul',_vm._l((_vm.files),function(file,index){return _c('li',{key:index},[_c('a',{staticClass:"inline-label",attrs:{"href":file.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('span',[_c('IconFilePdf',{attrs:{"width":24,"height":24}})],1),_c('div',[_vm._v(_vm._s(file.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }